module.exports = __webpack_public_path__ + "img/组 126(5).d0ba85d9.png";